import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=31c43e9d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=31c43e9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c43e9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c43e9d')) {
      api.createRecord('31c43e9d', component.options)
    } else {
      api.reload('31c43e9d', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=31c43e9d&scoped=true&", function () {
      api.rerender('31c43e9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20n1FVUAtIkjU/JS/comp/Voucher.vue"
export default component.exports